import api from 'api';
import storage from "@/cflow/storageService";

class procedimentoProtetico{

    listar(dados, skip, protetico = 0, getProtList = 0) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/procedimento-protetico?skip=' + skip + '&idProt=' + protetico + '&getProtList=' + getProtList + '&token='+user.token, dados).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    opcoesFiltro() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/procedimento-protetico?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/procedimento-protetico/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvar(id, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            id = (id) ? '/' + id : '';
            api.post('/procedimento-protetico/cadastro' + id + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    excluir(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.delete('/procedimento-protetico/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    buscarPorLab(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/procedimento-protetico/lab/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new procedimentoProtetico();